
























import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import { ListOption } from '@/interfaces/registration/ListOption';
import { DateInput } from '@/interfaces/registration/DateInput';
import { namespace } from 'vuex-class';
const utils = namespace('utils');

@Component
export default class FormDateInput extends Mixins(FormFieldMixin) {
  @Prop() readonly value!: Date;
  @Prop() readonly minValue?: Date;
  @Prop() readonly maxValue?: Date;

  private isDateRangeValid = true;

  public model: DateInput = {
    day: this.value?.getDate(),
    month: this.value?.getMonth(),
    year: this.value?.getFullYear()
  };

  @utils.State
  public days!: Array<ListOption>;

  @utils.State
  public months!: Array<ListOption>;

  public updated (): void {
    if (this.value && !this.model.day && !this.model.month && !this.model.year) {
      const valueDate = new Date(this.value);
      this.model.day = valueDate ? valueDate.getDate() : undefined;
      this.model.month = valueDate ? valueDate.getMonth() + 1 : undefined;
      this.model.year = valueDate ? valueDate.getFullYear() : undefined;
    }
  }

  public valueChanged (): void {
    if (this.model.day !== undefined && this.model.day > 0 &&
      this.model.month !== undefined && this.model.month > 0 &&
      this.model.year !== undefined && this.model.year > 0) {
      const date = new Date(this.model.year, this.model.month - 1, this.model.day);
      this.isDateRangeValid = !(date && ((this.minValue && date < new Date(this.minValue)) || (this.maxValue && date > new Date(this.maxValue))));
      this.$emit('input', date);
    } else {
      this.$emit('input', undefined);
    }
  }
}
